'use strict';

var chunkRX6S2VJY_js = require('./chunk-RX6S2VJY.js');
var chunkATB4Z7GO_js = require('./chunk-ATB4Z7GO.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var e = require('react');
var o = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var e__default = /*#__PURE__*/_interopDefault(e);
var o__default = /*#__PURE__*/_interopDefault(o);

var p=o__default.default.div`
  background-color: ${({$imageLinkConfig:t})=>t.backgroundColor};
  height: ${({$imageLinkConfig:t})=>t.height};
  width: ${({$imageLinkConfig:t})=>t.width};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({$imageLinkConfig:t})=>t.borderRadius};
`,k=o__default.default.img`
  max-height: ${({$imageLinkConfig:t})=>t.imageHeight};
  padding: ${({$imageLinkConfig:t})=>t.imagePadding};
`,f=o__default.default.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
`,I=o__default.default.span`
  margin-bottom: ${({$imageLinkConfig:t})=>t.textMarginBottom};
`,$=({url:t="/",imageUrl:a="",title:n="",device:i="msite",showLinkTitle:y=!0,target:l="_self"})=>{let{tokens:g}=chunkHUKGHOBJ_js.b(),{variants:r}=chunkRX6S2VJY_js.a(g);return e__default.default.createElement(p,{$imageLinkConfig:r[i]},t&&e__default.default.createElement(f,{href:t,target:l},a&&e__default.default.createElement(k,{$imageLinkConfig:r[i],src:a,alt:n}),y&&n&&e__default.default.createElement(I,{$imageLinkConfig:r[i]},e__default.default.createElement(chunkATB4Z7GO_js.a,{color:g.text_default_text_primary},n))))};

exports.a = $;
